import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import sessionsTimelineGrouped, { SessionsTimelineGroupedOutput } from '../../utils/sessionsTimelineGrouped'
import type { Fixture as LargeVisionFixture } from '../types'

/**
 * Large Vision Sessions timeline reducer
 */
const largeVisionSessionsTimeline = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_SESSIONS_TIMELINE,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_SESSIONSTIMELINE.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_SESSIONSTIMELINE.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_SESSIONSTIMELINE.failure,
    },
    transform: (state, { payload = {} }): SessionsTimelineGroupedOutput => {
        return sessionsTimelineGrouped<LargeVisionFixture>(payload)
    },
})

export default largeVisionSessionsTimeline
